export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40df0053412c71dcc505100c3a2abe34636f45aebc&name=revalidateCommunity!'